module.exports = new __parcel__URL__("leaderboard_title.c7e9b0f7.png").toString();